import { Injectable, Component } from "@angular/core";
import { Router, NavigationEnd } from '@angular/router';
const MINUTES_UNITL_AUTO_LOGOUT = 30 // in mins
const CHECK_INTERVAL = 15000 // in ms
const STORE_KEY =  'lastAction';
// declare const statistic: any;
@Injectable()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent {
  title = 'OSRTC Portal';
  constructor(
    private router: Router) {
    // router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     statistic(window.location.pathname);
    //   }
    // });
  }
}
export class ApiResponse {
  data: any;
  message: string;
  issuccess: boolean;
  exception: string;
  rowcount: number;
}